<script lang="ts">
  import { slide } from 'svelte/transition';
  import { quintOut } from 'svelte/easing';
  import {
    ArrowLeftIcon,
    CheckmarkCircleLargeIcon,
    PhoneAltIcon,
  } from '../../components/icons';
  import { Button } from 'core-components';
  import type { GlobalProperties } from 'customer-components/lib/types';

  export let sent = false;
  export let phone:
    | GlobalProperties['generalSettings']['contacts']['phone']
    | null;
  export let isSplit = false;
  export let hasCard = false;
  export let isFromCTA = false;
</script>

{#if sent}
  <div
    class="form-sent"
    class:cta={isFromCTA}
    class:card={hasCard}
    class:is-split={isSplit}
    transition:slide={{ duration: 300, easing: quintOut }}
  >
    <CheckmarkCircleLargeIcon />
    <div class="form-sent-content">
      <p class="title">Thank you!</p>
      <p class="description">
        Our team is on it and will get back to you shortly.
        <br />
        In the meantime, feel free to explore other sections of our website.
      </p>
      <div class="form-sent-actions">
        <Button variant="priority" on:click={() => (sent = false)}>
          <ArrowLeftIcon />
          Send Another Message
        </Button>
        {#if phone?.enabled}
          <span class="or">or</span>
          <a href="tel:{phone?.value}" class="call">
            <PhoneAltIcon />
            Call Us {phone?.value}
          </a>
        {/if}
      </div>
    </div>
  </div>
{/if}

<style lang="scss">
  .form-sent {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-xsmall);

    &.card {
      --text-color: var(--color-neutralBlack);
      width: 100%;
      background: #fff;
      border: 1px solid #ebedef;
      border-radius: var(--spacing-small-xl);
      box-shadow:
        0px 4px 6px -2px rgba(16, 24, 40, 0.03),
        0px 12px 16px -4px rgba(16, 24, 40, 0.08);
      box-sizing: border-box;
      padding: var(--spacing-large);
    }

    &.cta {
      height: 325px;
    }

    :global(svg) {
      flex-shrink: 0;
    }

    &:not(&.is-split) {
      margin-top: var(--spacing-large);
    }

    &-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 26px;
      color: var(--text-color);
    }

    .title {
      font-size: 24px;
      font-weight: 700;
      line-height: 32px;
    }

    .description {
      text-align: center;
      line-height: 24px;
      letter-spacing: 0.08px;
    }

    &-actions {
      display: flex;
      flex-direction: column;
      align-items: center;

      .or {
        margin: var(--spacing-micro) 0 var(--spacing-nano) 0;
      }

      .call {
        display: flex;
        gap: var(--spacing-micro);
        padding: var(--spacing-nano);
        color: var(--text-color);
        font-weight: 500;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }
</style>
